import template from './inceptionHeader.html';
import controller from './inceptionHeader.controller';
import './inceptionHeader.scss';

let inceptionHeaderComponent = {
  restrict: 'E',
  bindings: {
    view: '<',
    views: '<',
    onExitInception: '&',
    onChangeView: '&',
    availableVacations: '<',
    currentEmployee: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default inceptionHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendarMobile/inceptionHeader/inceptionHeader.component.js